import React from "react";
var __jsx = React.createElement;
import CardOptions from "./CardOptions";
var ScreenCard = function ScreenCard(_ref) {
  var screenData = _ref.screenData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-lg border border-solid border-gray-azureish py-6 px-4 flex flex-col gap-8 lg:border-0 lg:p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text text-base font-bold text-start"
  }, screenData === null || screenData === void 0 ? void 0 : screenData.title), (screenData === null || screenData === void 0 ? void 0 : screenData.description) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-30 text-xs font-semibold"
  }, screenData === null || screenData === void 0 ? void 0 : screenData.description))), /*#__PURE__*/React.createElement(CardOptions, {
    screenData: screenData
  })));
};
export default ScreenCard;